import type { VideoFile } from '@vimeo/gctl-api/models/components/schemas/video-file/VideoFile';

type TOptions = {
  allowDownloadOriginal?: boolean;
};

export const filterVideoFilesForKnownResolutionThenSortAlphabetically = (
  files: VideoFile[],
  options: TOptions = { allowDownloadOriginal: true },
): VideoFile[] => {
  const allowedQualities = ['hd', 'sd', 'uhd'].concat(
    options.allowDownloadOriginal ? ['source'] : [],
  ) as VideoFile['quality'][];

  return files
    .filter((file) => allowedQualities.includes(file.quality))
    .sort((fileA, fileB) => {
      if (fileA.quality === 'source') {
        return -1;
      }
      return fileB.height - fileA.height;
    });
};
